import { FSetupGraph } from '../../graph/index.js';
import { StoreProvider } from '../StoreProvider/StoreContext.js';

import { GraphContext } from './GraphContext.js';

export interface GraphProviderProps {
  graph: FSetupGraph;
  children: React.ReactNode;
}

export const GraphProvider: React.FC<GraphProviderProps> = ({ graph, children }) => {
  return (
    <GraphContext.Provider value={graph}>
      <StoreProvider store={graph.store}>{children}</StoreProvider>
    </GraphContext.Provider>
  );
};
